import './App.css';
import Spirograph from './components/Spirograph';

function App() {
  return (
    <div className="App">
      <Spirograph/>
    </div>
  );
}

export default App;
